import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import Settings from "./Settings";
import Auth from "./Auth";
import Notes from "./Notes";
import Contact from "./Contact";
import Teams from "./Teams";
import Meets from "./Meets";
import Common from "./Common";
import Meetings from "./zoom/Meetings";
import Profile from "./user/Profile";


const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  notes: Notes,
  contact: Contact,
  common: Common,
  meetings: Meetings,
  user: Profile,
  teams: Teams,
  meets: Meets
});

export default createRootReducer
